export interface GetArticleOptions {
  id: string;
  tag: string;
  page: string;
  take: string;
}
export interface ArticleModel {
  pageId: number;
  url: string;
  title: string;
  text: string;
  imageUrl: string;
  imageAltText: string;
  imageQuality: number | null;
  tag: string[];
}
export interface ArticleListModel {
  pageList: Array<ArticleModel>;
  urlToMagazine: string;
  hasMoreArticles: boolean;
  nextPageNr: number;
}

export const magazineArticlesService = ({ id, tag, page, take }: GetArticleOptions): Promise<ArticleListModel> => {
  return fetch(`/api/MagazineOverview/GetArticles?pageId=${id}&tag=${tag}&pagenr=${page}&take=${take}`)
    .then((res) => res.json())
    .then((data: ArticleListModel) => {
      return data;
    });
};

export const relatedArticlesBlockService = (pageIdList: string): Promise<ArticleListModel> => {
  return fetch(`/api/MagazineOverview/GetRelatedArticles?pageIds=${pageIdList}`)
    .then((res) => res.json())
    .then((data: ArticleListModel) => {
      return data;
    });
};
